import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import TransactionTable from '@/components/Transaction/table';
import { useBeforeRender } from '@/hooks/useBeforeRender';
import { DashboardService } from '@/services';
import { GlobalContext } from '@/contexts/GlobalContext';
import { formatCurrency } from '@/utils/formatter';

import './index.scss';

function TransactionsContainer() {
  const { t } = useTranslation();
  const [summary, setSummary] = useState({
    confirmPendingAmount: '0',
    paymentCompletedAmount: '0',
    paymentPendingAmount: '0',
    totalAmount: '0',
  });
  const { setPageTitle } = useContext(GlobalContext);
  const fetchData = async () => {
    const { success, data } = await DashboardService.getTransactionSummary();
    if (success) {
      setSummary({ ...data });
    }
  };

  useBeforeRender(() => fetchData(), []);

  useEffect(() => {
    setPageTitle('Transactions');
  }, [setPageTitle]);

  return (
    <div className="transactions">
      <Row gutter={[10, 10]} className="transactions__summary">
        <Col lg={{ span: 6 }} md={{ span: 12 }} span={24}>
          <div className="transactions__summary__item">
            <p className="transactions__summary__item__label">
              {t('transactions_page.main_content.total')}
            </p>
            <div className="transactions__summary__item__group">
              <p className="transactions__summary__item__price">
                {formatCurrency(summary.totalAmount || 0)}
              </p>
              <span className="transactions__summary__item__icon --total" />
            </div>
          </div>
        </Col>
        <Col lg={{ span: 6 }} md={{ span: 12 }} span={24}>
          <div className="transactions__summary__item">
            <p className="transactions__summary__item__label">
              {t('transactions_page.main_content.balance')}
            </p>
            <div className="transactions__summary__item__group">
              <p className="transactions__summary__item__price">
                {summary.paymentCompletedAmount
                  ? parseFloat(summary.paymentCompletedAmount).toLocaleString()
                  : 0}
              </p>
              <span className="transactions__summary__item__icon --balance" />
            </div>
          </div>
        </Col>
        <Col lg={{ span: 6 }} md={{ span: 12 }} span={24}>
          <div className="transactions__summary__item">
            <p className="transactions__summary__item__label">
              {t('transactions_page.main_content.waiting_for_approval')}
            </p>
            <div className="transactions__summary__item__group">
              <p className="transactions__summary__item__price">
                {summary.confirmPendingAmount
                  ? parseFloat(summary.confirmPendingAmount).toLocaleString()
                  : 0}
              </p>
              <span className="transactions__summary__item__icon --approval" />
            </div>
          </div>
        </Col>
        <Col lg={{ span: 6 }} md={{ span: 12 }} span={24}>
          <div className="transactions__summary__item">
            <p className="transactions__summary__item__label">
              {t('transactions_page.main_content.waiting_for_payment')}
            </p>
            <div className="transactions__summary__item__group">
              <p className="transactions__summary__item__price">
                {summary.paymentPendingAmount
                  ? parseFloat(summary.paymentPendingAmount).toLocaleString()
                  : 0}
              </p>
              <span className="transactions__summary__item__icon --payment" />
            </div>
          </div>
        </Col>
      </Row>
      <div className="transactions__card">
        <TransactionTable isFilter />
      </div>
    </div>
  );
}

export default TransactionsContainer;
